import React from "react";
import { Row, Col, Tooltip, Card, Skeleton, Spin } from "antd";
import moment from "moment";
// import {  CommercialIcon,
//     MailIcon,
//     PhoneIcon,
//     EditIcon,
// } from "../../common/CustomIcon";
import AddressInfo from "../../components/common/AddressInfo";
import AddressLocationMap from "../../components/orders/AddressLocationMap";
import { formamtAddressType, formatFullName, formatLocationName } from "../../helpers/common";
import LocationIcon from "../../../assets/images/map.png";
import ViewmoreIcon from "../../../assets/images/ViewMore.svg";
import ExpediteChip from "../../../assets/images/Expedite.svg";
import CommercialIcon from "../../../assets/images/Commercial.svg";
import PhoneIcon from "../../../assets/images/PhoneIcon.svg";
import MailIcon from "../../../assets/images/EmailIcon.svg";
import StatusCompleteChip from "../../../assets/images/StatusChip.svg";
import RabbitIcon from "../../../assets/images/Speedy.svg";
import AutographIcon from "../../../assets/images/Autograph.svg";
import EditIcon from "../../../assets/images/EditIcon.svg";

const AddressLocationCard = ({
  location,
  orderTypeConfig,
  emptyText,
  showActions,
  renderTitleAddressDetails,
  positionEditModal,
  setIsAddressFormScreen,
  isCrossDock,
  orgSettings,
  config,
  configLoading = false
}) => {
  return (
    <>
      <Row className="address-location-card" data-testid="address-section" type="flex" gutter={[16, 16]}>
        <Col xs={24} xl={8} className="image-container">
          <div className="image-wrapper">
            <div className="location-image">
              <AddressLocationMap
                location={location}
                orderTypeConfig={orderTypeConfig}
              />
            </div>
          </div>
        </Col>
        {!isCrossDock ? 
        <Col xs={24} xl={16} className="address-container">
          <Row gutter={[8, 8]} className="address-container-row">
            <Col className="address-location-name">
              <span className="address">
              {configLoading ? (
                <span className="loading-text">
                  Loading<span className="loading-dots">...</span>
                </span>
              ) : (
                config?.show_only_company_name === "true"
                  ? (location?.company_name || formatFullName(location, "customer_first_name", "customer_last_name") || "N/A")
                  : formatLocationName(location, "customer_first_name", "customer_last_name", (orgSettings?.prioritize_company_in_location === "true"))
              )}
              </span>
              <br />
              <span className="address-location">
                {location?.address ? (
                  <AddressInfo address={location.address} />
                ) : (
                  emptyText
                )}
              </span>
            </Col>
            <Col className="address-location-details">
              <Row>
                <Col lg={12} xs={24} style={{ display: "flex", gap: "5px" }}>
                  <img src={CommercialIcon} alt="" />
                  <span className="details-text">
                    {formamtAddressType((location?.address_type || "") , emptyText) }
                  </span>
                </Col>
                <Col lg={12} xs={24} style={{ display: "flex", gap: "5px" }}>
                  <img src={MailIcon} alt="" />
                  <span
                    className="details-text"
                    style={{ overflow: "hidden", textOverflow: "ellipsis" }}
                  >
                    <Tooltip
                      title={location?.email || ""}
                      overlayClassName="account-view-tooltip"
                    >
                      {location?.email || emptyText}
                    </Tooltip>
                  </span>
                </Col>
              </Row>
              <Row>
                <Col lg={12} xs={24} style={{ display: "flex", gap: "5px" }}>
                  <img src={PhoneIcon} alt="" />
                  <span className="details-text">
                    {location?.phone
                      ? location.phone.startsWith("+")
                        ? location.phone
                        : `+${location.phone}`
                      : emptyText}
                  </span>
                </Col>
                <Col lg={12} xs={24} style={{ display: "flex", gap: "5px" }}>
                  <img src={PhoneIcon} alt="" />
                  <span className="details-text">
                    {location?.phone_2
                      ? location.phone_2.startsWith("+")
                        ? location.phone_2
                        : `+${location.phone_2}`
                      : emptyText}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          {showActions && !((orderTypeConfig.code === "LH"||orderTypeConfig.code === "NLH" || orderTypeConfig.code === "LHD") && location.label_code === "ORN") && (
            // <Col className="address-location-edit" xl={2}>
            <img
              data-testid="edit-address-details-icon"
              className="address-location-edit"
              src={EditIcon}
              alt=""
              onClick={(event) => {
                renderTitleAddressDetails(
                  "addressDetails",
                  "Address Details",
                  true
                );
                positionEditModal(event, "addressDetails");
                setIsAddressFormScreen(true);
              }}
            />
            // </Col>
          )}
        </Col> :
        <Col xs={24} xl={16} className="address-container">
        <Row gutter={[8, 8]} className="address-container-row">
          <Col className="address-location-name">
            <span className="address">
              {location?.company_name ? `${location?.company_name}` : emptyText}
            </span>
          </Col>
          <Col className="address-location-details">
            <Row gutter={[5, 16]}>
              <Col lg={24} xs={24} style={{ display: "flex", gap: "5px" }}>
                <img src={MailIcon} alt="" />
                <span
                  className="details-text"
                  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
                >
                  <Tooltip
                    title={location?.email || ""}
                    overlayClassName="account-view-tooltip"
                  >
                    {location?.email || emptyText}
                  </Tooltip>
                </span>
              </Col>
            </Row>
            <Row>
              <Col lg={24} xs={24} style={{ display: "flex", gap: "5px" }}>
                <img src={PhoneIcon} alt="" />
                <span className="details-text">
                  {location?.phone
                    ? location.phone.startsWith("+")
                      ? location.phone
                      : `+${location.phone}`
                    : emptyText}
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
        {showActions && (
          <Col className="address-location-edit" xl={2}>
          <img
            data-testid="edit-address-details-icon"
            className="address-location-edit"
            src={EditIcon}
            alt=""
            onClick={(event) => {
              renderTitleAddressDetails(
                "addressDetails",
                "Address Details",
                true
              );
              positionEditModal(event, "addressDetails");
              setIsAddressFormScreen(true);
            }}
          />
          </Col>
        )}
      </Col>}
      </Row>
    </>
  );
};

export default AddressLocationCard;
